import { Outlet } from "react-router-dom";
import BottomNav from "./BottomNav";

export default function Layout() {
    return (
        <div className="min-h-screen bg-background text-foreground vf-grain pb-32">
            <Outlet />
            <BottomNav />
        </div>
    );
}
